/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AutomationTemplateQuerySubClassification extends models.QueryOperator {
    constructor() {
        super();
        this.setDiscriminator("AutomationTemplateQuerySubClassification");
    }

    getFixupPrototypeFunction() { return AutomationTemplateQuerySubClassification.fixupPrototype; }

    static newInstance(model: Partial<AutomationTemplateQuerySubClassification>): AutomationTemplateQuerySubClassification {
        let obj = Object.assign(new AutomationTemplateQuerySubClassification(), model);
        AutomationTemplateQuerySubClassification.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AutomationTemplateQuerySubClassification>): AutomationTemplateQuerySubClassification {
        if (!model) return null;
        return AutomationTemplateQuerySubClassification.newInstance(<AutomationTemplateQuerySubClassification> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AutomationTemplateQuerySubClassification) {
        if (!obj) return;

        models.AutomationTemplateQuerySubClassification.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AutomationTemplateQuerySubClassification): boolean {
        if (models.QueryOperator.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, AutomationTemplateQuerySubClassification.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Template sub-classifications to include
     */
    sub_classifications: Array<string>;

}
